import { create } from 'zustand';
import { immerMiddleware } from '../services/Utils';
import { BUSINESS_TYPE } from '../types/userTypings';

const appStore = () => ({
  appSocket: null,
  appTheme: '',
  messages: 0,
  notifications: 0,
  subscriptionType: BUSINESS_TYPE.FREE,
  isLoaded: false,
  showLogoOnShareUuid: ''
});

export const useAppStore = create(immerMiddleware(appStore));
